'use strict';

class Cart {
  constructor(items) {
    this.items = [];
    if (items && items instanceof Array) {
      items.forEach(item => this.addItem(item));
    }
  }

  getKey(item) {
    return `${item.dealUuid}-${item.uuid}`;
  }

  createItem(newItem, index) {
    return {
      key: this.getKey(newItem),
      uuid: newItem.uuid,
      dealUuid: newItem.dealUuid,
      quantity: 1,
      index: index,
    };
  }

  getItem(item) {
    const itemIndex = this.findItemIndex(item);
    if (itemIndex >= 0) {
      return this.items[itemIndex];
    } else {
      return false;
    }
  }

  addItem(item) {
    const itemToAdd = this.getItem(item);
    if (itemToAdd) {
      itemToAdd.quantity += 1;
    } else {
      this.items.push(this.createItem(item, this.items.length));
    }
  }

  removeItem(item) {
    const index = this.findItemIndex(item);
    if (index >= 0) {
      this.items[index].quantity -= 1;
      if (this.items[index].quantity <= 0) {
        this.items.splice(index, 1);
      }
      return true;
    } else {
      return false;
    }
  }

  findItemIndex(itemToFind) {
    const itemKey = this.getKey(itemToFind);
    for (let i = 0; i < this.items.length; i++) {
      if (this.items[i].key === itemKey) return i;
    }
    return -1;
  }

  getItems() {
    return this.items;
  }

  clean() {
    this.items = [];
  }
}

module.exports = Cart;
